/// <reference path="ad.d.ts" />

import { Component, OnInit, AfterViewInit } from '@angular/core';


@Component({
  selector: 'app-ad',
  templateUrl: './ad.component.html',
  styleUrls: ['./ad.component.css']
})
export class AdComponent implements OnInit, AfterViewInit {

  constructor() { }

  ngOnInit() {

  }


  ngAfterViewInit() {
    try {
      (adsbygoogle = window.adsbygoogle || []).push({});
    } catch (e) {}
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src946329470/src/frontend/src/app/ad/ad.component.ts